import checkBoxIcon from "assets/wealth/icons/check_box.svg";
import checkBoxCheckedIcon from "assets/wealth/icons/check_box_checked.svg";
import { areAbsolutelyEqual } from "helpers/commonFunctions";
import ErrorMessage from "components/form/ErrorMessage";
import React, { useMemo } from "react";
import {
  Box,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import NumberField from "../../../NumberField";
import SelectField from "../../../SelectField";

const TableContent = ({
  listAnswer,
  control,
  field,
  error,
  name,
  disabled,
}) => {
  const tableHeader = useMemo(() => {
    return listAnswer?.find((i) => i.subType === "ROW_HEADER").children;
  }, [listAnswer]);

  const tableRows = useMemo(() => {
    return listAnswer?.filter((i) => i.subType === "ROW_QUESTION");
  }, [listAnswer]);
  const handleChangeCheckbox = (answerId) => (event) => {
    const value = field.value || [];
    const index = value.findIndex((item) => item.answerId === answerId);
    if (index >= 0) {
      value.splice(index, 1);
    }
    if (event.target.checked) {
      value.push({ answerId });
    }
    field.onChange([...value]);
  };
  const handleChangeTextbox = (answerId) => (event) => {
    const value = field.value || [];
    const index = value.findIndex((item) => item.answerId === answerId);
    if (index >= 0) {
      value.splice(index, 1);
    }
    if (event.target.value) {
      value.push({ answerId, text: event.target.value });
    }
    field.onChange([...value]);
  };
  const checkIndex = (answerId) => {
    const value = field.value || [];
    return value.findIndex((item) => item.answerId === answerId);
  };
  const handleChangeNumberField = (answerId, numberValue) => {
    const value = field.value || [];
    const index = value.findIndex((item) => item.answerId === answerId);
    if (index >= 0) {
      value.splice(index, 1);
    }
    if (numberValue || numberValue === 0) {
      value.push({ answerId, text: numberValue });
    }
    field.onChange([...value]);
  };
  const renderCellBySubType = (r) => {
    let err;
    if (Array.isArray(error)) {
      err = error?.find((i) => {
        return i?.text?.message?.answerId === r?.elementId;
      });
    }
    switch (r.subType) {
      case "CHOICE_ANSWER":
        return (
          <Checkbox
            icon={<img style={{ width: 16 }} src={checkBoxIcon} alt="" />}
            checkedIcon={
              <img style={{ width: 16 }} src={checkBoxCheckedIcon} alt="" />
            }
            onChange={handleChangeCheckbox(r.elementId)}
            disabled={disabled}
            checked={
              checkIndex(r.elementId) >= 0 ||
              areAbsolutelyEqual(r.answerText, r.title)
            }
          />
        );
      case "CELL_TITLE":
        return <Typography>{r.title}</Typography>;
      case "TEXT_ANSWER":
        return (
          <TextField
            onChange={handleChangeTextbox(r.elementId)}
            variant="outlined"
            size="small"
            disabled={disabled}
            value={r.answerText ?? null}
            sx={{
              "& .MuiInputBase-input": {
                height: "10px",
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#000000de", // màu chữ
              },
              width: "80px",
            }}
          />
        );
      case "NUMBER_ANSWER":
        return (
          <NumberField
            onChange={(e) => {
              handleChangeNumberField(r.elementId, e?.target?.value ?? null);
            }}
            error={err}
            disabled={disabled}
            value={
              r.answerText
                ? Number(r.answerText)
                : checkIndex(r.elementId) >= 0
                ? field.value.find((item) => item.answerId === r.elementId)
                    ?.text
                : null
            }
            variant="outlined"
            size="small"
            min={r.min}
            max={r.max}
            thousandSeparator
            isNumericString
            textFieldSx={{
              "& .MuiInputBase-input": {
                height: "10px",
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#000000de", // màu chữ
              },
              width: "100px",
            }}
          />
        );
      case "DROP_LIST_ANSWER":
        return (
          <SelectField
            onChange={handleChangeTextbox(r.elementId)}
            uuidRef={r.uuidRef}
            disabled={disabled}
            answer={r}
            fieldValue={
              field?.value
                ? field?.value?.find((i) => i.answerId === r.elementId)
                : null
            }
            sx={{
              "& .MuiSelect-outlined": {
                padding: "2px 14px",
              },
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: "#000000de", // màu chữ
              },
            }}
          />
        );
      default:
        return <></>;
    }
  };
  return (
    <Box
      sx={{
        width: "100%",
      }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  border: "none",
                }}
              >
                {" "}
              </TableCell>
              {tableHeader.map((col, colIdx) => (
                <TableCell
                  key={col.elementId}
                  align="center"
                  sx={{
                    position: "relative",
                    border: "none",
                  }}
                >
                  <Typography>{col.title}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.map((row, rowIndex) => (
              <TableRow
                key={row.elementId}
                sx={{
                  background: rowIndex % 2 === 0 ? "#F1F1F1" : "#F8F8F8",
                }}
              >
                <TableCell
                  component="td"
                  scope="row"
                  sx={{
                    paddingX: 1,
                    border: "none",
                    maxWidth: "200px",
                  }}
                >
                  <Typography>{row.title}</Typography>
                </TableCell>
                {row.children.map((r, rIdx) => (
                  <TableCell
                    key={r.elementId}
                    component="td"
                    scope="row"
                    align="center"
                    sx={{
                      paddingX: 1,
                      border: "none",
                    }}
                  >
                    {renderCellBySubType(r)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {error?.message && <ErrorMessage message={error?.message} />}
    </Box>
  );
};

export default TableContent;
